// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-details label {
  font-size: 12px;
  margin: 8px 0;
}
.popup-details label .active-taskname {
  color: #003da5;
  padding-left: 5px;
}
.popup-details .p-dialog-content {
  overflow-y: none !important;
}
.popup-details .tasksname {
  display: block !important;
}
.popup-details .tasksname ul {
  list-style: none;
  padding: 0 0px !important;
  max-height: 200px !important;
  overflow-y: auto;
}
.popup-details .tasksname ul li {
  padding: 5px 0;
}
.popup-details .acp-dialog .p-dialog-content {
  padding: 0 0 0 0 !important;
  overflow-y: hidden !important;
}
.popup-details .booking-dialog-acp {
  font-weight: 900;
  font-size: 18px !important;
  text-align: left;
  color: #003da5 !important;
}
.popup-details .p-autocomplete-dropdown,
.popup-details .p-inputtext {
  border: 0;
  background: #ffffff;
  /* Light Grey */
  height: 30px;
  box-shadow: none !important;
  outline: none !important;
}
.popup-details .p-autocomplete {
  width: 200px;
  border: 1px solid #acacac;
  border-radius: 4px;
}
.popup-details .help-user {
  margin-top: 10px;
}
.popup-details .p-inputtextarea {
  width: 100%;
  border-radius: 14px;
  height: 200px;
  margin: 10px 0;
  border: 1px solid #acacac;
}
.popup-details .p-button-icon {
  color: #adadad;
}

#delegate-submit,
#help-submit {
  padding: 0 !important;
  display: flex;
}

#delegate-submit {
  justify-content: flex-end;
}

#help-submit {
  justify-content: space-between;
}

.comments-validation {
  font-size: 12px;
  padding: 0;
}

.p-dialog .p-dialog-header {
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
}

.popup-details {
  min-height: 100px !important;
}

.row-fields {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}

.p-dialog .p-dialog-header .p-dialog-header-icon:enabled:hover {
  color: #343a40;
  border-color: transparent !important;
  background: transparent !important;
  box-shadow: none !important;
}

.acp-select-box {
  width: 100%;
  margin-bottom: 30px;
}

.acp-dialog .start-date-wrapper {
  margin-left: 10px;
}
.acp-dialog .start-date-wrapper h6 {
  color: #595959;
  font-weight: bold;
}
.acp-dialog .p-dialog-content {
  overflow-y: scroll;
  border-radius: 0 0 6px 6px;
  padding: 20px 32px 20px 32px !important;
}
.acp-dialog .popup-details {
  padding-top: 0 !important;
}
.acp-dialog .popup-details label {
  color: #595959;
  font-weight: bold;
}
.acp-dialog .popup-details .tasksname ul {
  margin-bottom: 30px;
  padding: 0 0px !important;
  min-width: 384px !important;
  max-height: 120px !important;
}
.acp-dialog .massUpdateFooter {
  margin-bottom: 0 !important;
  right: 0 !important;
  margin-right: 0 !important;
}
.acp-dialog .massUpdateFooter .btn {
  font-weight: bold;
}
.acp-dialog .acp-download-btn {
  color: #000;
}
.acp-dialog .acp-download-btn a {
  color: #003da5 !important;
  text-decoration: none;
}
.acp-dialog .acp-download-btn img {
  margin-right: 5px;
}

.upload-long-term .file-list-data-row:nth-child(1) {
  max-width: 300px !important;
}
.upload-long-term .p-dialog-content {
  padding: 20px 32px 0px 32px !important;
}

.manage-cap .p-dialog-content {
  padding: 20px 32px 60px 32px !important;
}

.acp-dialog-footer {
  width: 100%;
  position: absolute;
  background: #f3f3f3;
  height: 4.5rem;
  bottom: 0;
  left: 0;
  z-index: 100;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  display: flex;
  align-items: center;
}
.acp-dialog-footer .acp-footer-buttons {
  position: absolute;
  bottom: 0.85rem;
}
.acp-dialog-footer .manage-cap-template {
  margin-left: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/ACP/common/AcpCommonDialog.scss"],"names":[],"mappings":"AACE;EACE,eAAA;EACA,aAAA;AAAJ;AAEI;EACE,cAAA;EACA,iBAAA;AAAN;AAIE;EACE,2BAAA;AAFJ;AAKE;EACE,yBAAA;AAHJ;AAKI;EACE,gBAAA;EACA,yBAAA;EACA,4BAAA;EACA,gBAAA;AAHN;AAKM;EACE,cAAA;AAHR;AAQE;EACE,2BAAA;EACA,6BAAA;AANJ;AASE;EACE,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,yBAAA;AAPJ;AAUE;;EAEE,SAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,2BAAA;EACA,wBAAA;AARJ;AAWE;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;AATJ;AAYE;EACE,gBAAA;AAVJ;AAaE;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;AAXJ;AAcE;EACE,cAAA;AAZJ;;AAgBA;;EAEE,qBAAA;EACA,aAAA;AAbF;;AAgBA;EACE,yBAAA;AAbF;;AAgBA;EACE,8BAAA;AAbF;;AAgBA;EACE,eAAA;EACA,UAAA;AAbF;;AAgBA;EACE,4BAAA;EACA,2BAAA;AAbF;;AAgBA;EACE,4BAAA;AAbF;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;AAbF;;AAgBA;EACE,cAAA;EACA,oCAAA;EACA,kCAAA;EACA,2BAAA;AAbF;;AAgBA;EACE,WAAA;EACA,mBAAA;AAbF;;AAiBE;EACE,iBAAA;AAdJ;AAgBI;EACE,cAAA;EACA,iBAAA;AAdN;AAkBE;EACE,kBAAA;EACA,0BAAA;EACA,uCAAA;AAhBJ;AAmBE;EACE,yBAAA;AAjBJ;AAmBI;EAEE,cAAA;EACA,iBAAA;AAlBN;AAsBM;EACE,mBAAA;EACA,yBAAA;EACA,2BAAA;EACA,4BAAA;AApBR;AAyBE;EACE,2BAAA;EACA,mBAAA;EACA,0BAAA;AAvBJ;AAyBI;EACE,iBAAA;AAvBN;AA2BE;EACE,WAAA;AAzBJ;AA2BI;EACE,yBAAA;EACA,qBAAA;AAzBN;AA4BI;EACE,iBAAA;AA1BN;;AAiCI;EACE,2BAAA;AA9BN;AAkCE;EACE,sCAAA;AAhCJ;;AAqCE;EACE,uCAAA;AAlCJ;;AAsCA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,8BAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;AAnCF;AAqCE;EACE,kBAAA;EACA,eAAA;AAnCJ;AAsCE;EACE,iBAAA;AApCJ","sourcesContent":[".popup-details {\n  label {\n    font-size: 12px;\n    margin: 8px 0;\n\n    .active-taskname {\n      color: #003da5;\n      padding-left: 5px;\n    }\n  }\n\n  .p-dialog-content {\n    overflow-y: none !important;\n  }\n\n  .tasksname {\n    display: block !important;\n\n    ul {\n      list-style: none;\n      padding: 0 0px !important;\n      max-height: 200px !important;\n      overflow-y: auto;\n\n      li {\n        padding: 5px 0;\n      }\n    }\n  }\n\n  .acp-dialog .p-dialog-content {\n    padding: 0 0 0 0 !important;\n    overflow-y: hidden !important;\n  }\n\n  .booking-dialog-acp {\n    font-weight: 900;\n    font-size: 18px !important;\n    text-align: left;\n    color: #003da5 !important;\n  }\n\n  .p-autocomplete-dropdown,\n  .p-inputtext {\n    border: 0;\n    background: #ffffff;\n    /* Light Grey */\n    height: 30px;\n    box-shadow: none !important;\n    outline: none !important;\n  }\n\n  .p-autocomplete {\n    width: 200px;\n    border: 1px solid #acacac;\n    border-radius: 4px;\n  }\n\n  .help-user {\n    margin-top: 10px;\n  }\n\n  .p-inputtextarea {\n    width: 100%;\n    border-radius: 14px;\n    height: 200px;\n    margin: 10px 0;\n    border: 1px solid #acacac;\n  }\n\n  .p-button-icon {\n    color: #adadad;\n  }\n}\n\n#delegate-submit,\n#help-submit {\n  padding: 0 !important;\n  display: flex;\n}\n\n#delegate-submit {\n  justify-content: flex-end;\n}\n\n#help-submit {\n  justify-content: space-between;\n}\n\n.comments-validation {\n  font-size: 12px;\n  padding: 0;\n}\n\n.p-dialog .p-dialog-header {\n  border-top-right-radius: 6px;\n  border-top-left-radius: 6px;\n}\n\n.popup-details {\n  min-height: 100px !important;\n}\n\n.row-fields {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.p-dialog .p-dialog-header .p-dialog-header-icon:enabled:hover {\n  color: #343a40;\n  border-color: transparent !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.acp-select-box {\n  width: 100%;\n  margin-bottom: 30px;\n}\n\n.acp-dialog {\n  .start-date-wrapper {\n    margin-left: 10px;\n\n    h6 {\n      color: #595959;\n      font-weight: bold;\n    }\n  }\n\n  .p-dialog-content {\n    overflow-y: scroll;\n    border-radius: 0 0 6px 6px;\n    padding: 20px 32px 20px 32px !important;\n  }\n\n  .popup-details {\n    padding-top: 0 !important;\n\n    label {\n      // margin: 0;\n      color: #595959;\n      font-weight: bold;\n    }\n\n    .tasksname {\n      ul {\n        margin-bottom: 30px;\n        padding: 0 0px !important;\n        min-width: 384px !important;\n        max-height: 120px !important;\n      }\n    }\n  }\n\n  .massUpdateFooter {\n    margin-bottom: 0 !important;\n    right: 0 !important;\n    margin-right: 0 !important;\n\n    .btn {\n      font-weight: bold;\n    }\n  }\n\n  .acp-download-btn {\n    color: #000;\n\n    a {\n      color: #003da5 !important;\n      text-decoration: none;\n    }\n\n    img {\n      margin-right: 5px;\n    }\n  }\n}\n\n.upload-long-term {\n  .file-list-data-row {\n    &:nth-child(1) {\n      max-width: 300px !important;\n    }\n  }\n\n  .p-dialog-content {\n    padding: 20px 32px 0px 32px !important;\n  }\n}\n\n.manage-cap {\n  .p-dialog-content {\n    padding: 20px 32px 60px 32px !important;\n  }\n}\n\n.acp-dialog-footer {\n  width: 100%;\n  position: absolute;\n  background: #f3f3f3;\n  height: 4.5rem;\n  bottom: 0;\n  left: 0;\n  z-index: 100;\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n  display: flex;\n  align-items: center;\n\n  .acp-footer-buttons {\n    position: absolute;\n    bottom: 0.85rem;\n  }\n\n  .manage-cap-template {\n    margin-left: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
